let dinamicOption = {
    position: 0,
    lastPosition: NaN,
    arrTweenAnimeSolo: [],
    arrTweenAnimeTrio: [],
}

export {dinamicOption}